import React, { useEffect, useState, useCallback, useMemo } from "react";
import Moment from "react-moment";
import AddNewMessage from "../AddNewMessage";
import MessagingPopup from "../MessagingPopup";
import { getFormatedNumber } from "../../Services/appService";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch } from "react-redux";
import {
  useLoadCandidateAppsQuery,
  useLoadPortalAppMessagesQuery,
  useLoadAppRuningTasksQuery,
} from "../../app/store/candidateApiSlice";
import { getAlert } from "../../Services/appAlerts";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";

const MESSAGE_STYLES = {
  pageWrap: {
    padding: "8px 0 4px 0"
  },
  shell: {
    borderRadius: "0px",
    border: "1px solid #e5e5e5",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  hero: {
    padding: "14px 20px",
    borderBottom: "1px solid #e5e5e5",
    background: "#ffffff"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#000000",
    fontSize: "14px",
    border: "1px solid #e5e5e5",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    flexShrink: 0
  },
  titleCopy: {
    minWidth: 0
  },
  title: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.25,
    color: "#000000",
    margin: 0
  },
  addButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    padding: "20px 22px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "0px",
    padding: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "14px",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    margin: "0 0 4px 0",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1
  },
  body: {
    padding: "0"
  },
  tableWrap: {
    overflowX: "auto",
    backgroundColor: "#ffffff"
  },
  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  tableHeadCell: {
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    borderBottom: "1px solid #e5e5e5",
    padding: "14px 16px"
  },
  cell: {
    padding: "14px 16px",
    borderBottom: "1px solid rgba(241, 245, 249, 1)",
    verticalAlign: "top",
    fontWeight: 600
  },
  serialBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 10px",
    borderRadius: "0px",
    backgroundColor: "#f1f5f9",
    border: "1px solid #e5e5e5",
    color: "#0f172a",
    fontSize: "12px",
    fontWeight: 600
  },
  dateText: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#0f172a"
  },
  officerAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "0px",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#0f172a",
    fontSize: "13px",
    fontWeight: 600,
    border: "1px solid #e5e5e5",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    flexShrink: 0
  },
  personName: {
    margin: 0,
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "uppercase"
  },
  metaLine: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#475569",
    fontSize: "12.5px",
    lineHeight: 1.45,
    fontWeight: 500
  },
  viewButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap"
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "18px",
    height: "18px",
    borderRadius: "0px",
    marginLeft: "6px",
    fontSize: "11px",
    fontWeight: 800,
    padding: "0 6px"
  },
  unreadBadge: {
    background: "#fee2e2",
    color: "#991b1b"
  },
  readBadge: {
    background: "#dcfce7",
    color: "#166534"
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center"
  },
  emptyText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: "10px auto 0 auto",
    fontWeight: "normal"
  }
};

const ROUTE_CANDIDATE = [{ url: "", name: "Task Management" }];
const ROUTE_PARTNER = [{ name: "Contract Management", url: "" }];

export default function IndividualMsg() {

  const usrType = useMemo(() => localStorage.getItem("userType"), []);

  const [msgShowHide, setMsgShowHide] = useState(false);
  const [addMsgShowHide, setAddMsgShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState("");
  const [wfTask, setWfTask] = useState(null);

  const dispatch = useDispatch();
  const currentUser = useMemo(() => getCurrentUser(), []);
  const usrId = currentUser?.linkUser || currentUser?.id;

  // RTK Query Hooks
  const { data: candidateAppsSelector = [] } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

  const { wfId } = useMemo(() => {
    const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
    const wf = mainWorkflow[0] || null;
    const wfId = wf?.oldWorkflowId || 0;
    return { wfId };
  }, [candidateAppsSelector]);

  const { data: appMessagesSelector = [], refetch: refetchAppMessages } = useLoadPortalAppMessagesQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );

  const { data: appTasksSelector = [] } = useLoadAppRuningTasksQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );

  const appMessages = appMessagesSelector;
  const appTasklist = useMemo(() => {
    return appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
  }, [appTasksSelector]);

  useEffect(() => {
    dispatch(setCurrentPageTitle("Message(s)"));
    dispatch(setCurrentRoute(usrType === "candidate" ? ROUTE_CANDIDATE : ROUTE_PARTNER));
  }, [dispatch, usrType]);

  const handleAddNewMessagePopup = useCallback((app) => {
    if (app === "save") {
      setAddMsgShowHide(false);
      refetchAppMessages();
    }
    else {
      const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
      if (reviewApp.length > 0) {
        const lastReviewer = reviewApp[reviewApp.length - 1];
        setWfTask([lastReviewer]);
      } else {
        getAlert("", "No reviewer found", "error");
      }
      setAddMsgShowHide(prev => !prev);
    }
  }, [appTasklist, refetchAppMessages]);

  const handleMessagePopup = useCallback((obj) => {
    setMsgShowHide(prev => !prev);
    setMsgObj(obj);
  }, []);

  const handleSendMessage = useCallback(() => {
    if (wfId > 0 && usrId) {
      refetchAppMessages();
    }
  }, [wfId, usrId, refetchAppMessages]);

  const totalMessages = appMessages.length;
  const unreadMessages = useMemo(() => {
    return appMessages.reduce((count, item) => count + (item.unreadCount || 0), 0);
  }, [appMessages]);

  const currentUserId = currentUser?.id;
  const activeReviewers = useMemo(() => {
    return new Set(
      appMessages
        .map((item) => (item.receiverId === parseInt(currentUserId) ? item.sender : item.receiver))
        .filter(Boolean)
    ).size;
  }, [appMessages, currentUserId]);

  const getInitials = (name) => {
    if (!name) return "??";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  return (
    <React.Fragment>
      <div className="col-md-12" style={MESSAGE_STYLES.pageWrap}>
        <div style={MESSAGE_STYLES.shell}>
          <div style={MESSAGE_STYLES.hero}>
            <div style={MESSAGE_STYLES.heroRow}>
              <div style={MESSAGE_STYLES.titleWrap}>
                <div style={MESSAGE_STYLES.titleIcon}>
                  <i className="fa fa-comments-o" aria-hidden="true"></i>
                </div>
                <div style={MESSAGE_STYLES.titleCopy}>
                  <h1 style={MESSAGE_STYLES.title}>Message Center</h1>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-sm"
                  style={MESSAGE_STYLES.addButton}
                  onClick={() => handleAddNewMessagePopup("")}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>
                  Add Message
                </button>
              </div>
            </div>
          </div>
          <div style={MESSAGE_STYLES.statsRow}>
            <div style={MESSAGE_STYLES.statCard}>
              <div style={MESSAGE_STYLES.statIcon}>
                <i className="fa fa-comments-o" aria-hidden="true"></i>
              </div>
              <div style={MESSAGE_STYLES.statContent}>
                <div style={MESSAGE_STYLES.statLabel}>Total Threads</div>
                <div style={MESSAGE_STYLES.statValue}>{totalMessages}</div>
              </div>
            </div>
            <div style={MESSAGE_STYLES.statCard}>
              <div style={MESSAGE_STYLES.statIcon}>
                <i className="fa fa-clock-o" aria-hidden="true"></i>
              </div>
              <div style={MESSAGE_STYLES.statContent}>
                <div style={MESSAGE_STYLES.statLabel}>Unread Replies</div>
                <div style={MESSAGE_STYLES.statValue}>{unreadMessages}</div>
              </div>
            </div>
            <div style={MESSAGE_STYLES.statCard}>
              <div style={MESSAGE_STYLES.statIcon}>
                <i className="fa fa-users" aria-hidden="true"></i>
              </div>
              <div style={MESSAGE_STYLES.statContent}>
                <div style={MESSAGE_STYLES.statLabel}>Contacts</div>
                <div style={MESSAGE_STYLES.statValue}>{activeReviewers}</div>
              </div>
            </div>
          </div>
          <div style={MESSAGE_STYLES.body}>
            <div style={MESSAGE_STYLES.tableWrap}>
              <div className="table-responsive">
                <table className="table align-items-center table-hover mb-0" style={MESSAGE_STYLES.table}>
                  <thead>
                    <tr>
                      <th style={MESSAGE_STYLES.tableHeadCell}>ID</th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Date & Time Submitted</th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Review Officer</th>
                      <th style={MESSAGE_STYLES.tableHeadCell}>Messages</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appMessages.length > 0 ? appMessages.map((item, key) => {
                      const officerName = item.receiverId === parseInt(currentUser?.id)
                        ? item.sender
                        : item.receiver;
                      return (
                        <tr key={item.id || key}>
                          <td style={MESSAGE_STYLES.cell}>
                            <span style={{ color: "#0f172a", fontWeight: 700 }}>#</span>{" "}
                            <span style={{ fontWeight: 600, color: "#0f172a" }}>{item.id || key + 1}</span>
                          </td>
                          <td style={MESSAGE_STYLES.cell}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                              <span style={{ fontSize: "13.5px", fontWeight: 600, color: "#0f172a" }}>
                                <Moment format="MMM Do, YYYY">
                                  {item.addedDateTime}
                                </Moment>
                              </span>
                              <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b" }}>
                                <Moment format="h:mm a">
                                  {item.addedDateTime}
                                </Moment>
                              </span>
                            </div>
                          </td>
                          <td style={MESSAGE_STYLES.cell}>
                            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                              <div style={MESSAGE_STYLES.officerAvatar}>
                                {getInitials(officerName)}
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                                <p style={MESSAGE_STYLES.personName}>{officerName}</p>
                                {item.role && (
                                  <div style={{ ...MESSAGE_STYLES.metaLine, color: "#0f172a", fontWeight: 500 }}>
                                    {item.role}
                                  </div>
                                )}
                                {item.email && (
                                  <div style={MESSAGE_STYLES.metaLine}>
                                    {item.email}
                                  </div>
                                )}
                                {item.contact && (
                                  <div style={MESSAGE_STYLES.metaLine}>
                                    {getFormatedNumber(item.contact)}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={MESSAGE_STYLES.cell}>
                            <button
                              className="btn btn-sm"
                              style={MESSAGE_STYLES.viewButton}
                              onClick={() => handleMessagePopup(item)}
                            >
                              <i className="fa fa-comments-o" aria-hidden="true"></i>
                              View Conversation
                              {item.unreadCount > 0 &&
                                <span style={{ ...MESSAGE_STYLES.countBadge, ...MESSAGE_STYLES.unreadBadge }}>
                                  {item.unreadCount}
                                </span>}
                              {item.readCount > 0 && item.unreadCount === 0 &&
                                <span style={{ ...MESSAGE_STYLES.countBadge, ...MESSAGE_STYLES.readBadge }}>
                                  {item.readCount}
                                </span>}
                            </button>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr>
                        <td colSpan="4" style={{ ...MESSAGE_STYLES.cell, padding: 0 }}>
                          <div style={MESSAGE_STYLES.emptyState}>
                            <div style={MESSAGE_STYLES.emptyIcon}>
                              <i className="fa fa-envelope-open-o" aria-hidden="true"></i>
                            </div>
                            <h4 style={MESSAGE_STYLES.emptyTitle}>No messages yet</h4>
                            <p style={MESSAGE_STYLES.emptyText}>
                              Your reviewer conversations will appear here. Use the Add Message button to start the first thread for this workflow.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddNewMessage
        addMsgShowHide={addMsgShowHide}
        handleAddMsgModalShowHide={handleAddNewMessagePopup}
        runningApplication={wfTask}
      ></AddNewMessage>

      <MessagingPopup
        msgShowHide={msgShowHide}
        message={msgObj}
        handleMsgModalShowHide={handleMessagePopup}
        handleSendMessage={handleSendMessage}
      ></MessagingPopup>

    </React.Fragment>
  );
}
